export const sortBenefits = benefits => {
  let topBenefits = []
  let standardBenefits = []

  benefits.forEach(benefit => {
    if (benefit.benefitType === 'top') topBenefits.push(benefit)
    else if (benefit.benefitType === 'standard') standardBenefits.push(benefit)
  })
  console.log('topBenefits: ', topBenefits)
  console.log('topBenefits: ', standardBenefits)

  let topBenefitsSorted = topBenefits
    .filter(benefit => !Number.isNaN(benefit.slNo))
    .sort((a, b) => a.slNo - b.slNo)

  console.log('topBenefitsSorted: ', topBenefitsSorted)
  let standardBenefitsSorted = standardBenefits
    .filter(benefit => !Number.isNaN(benefit.slNo))
    .sort((a, b) => a.slNo - b.slNo)

  let populatedTBenefits = [...Array(5).keys()].map((ele, indx) => {
    let result = topBenefitsSorted.find(benefit => benefit.slNo === indx + 1)
    if (result) return result
    else return {}
  })

  let populatedSBenefits = [...Array(15).keys()].map((ele, indx) => {
    let result = standardBenefitsSorted.find(benefit => benefit.slNo === indx + 1)
    if (result) return result
    else return {}
  })
  console.log('SORTED BENE', {
    topBenefits: populatedTBenefits,
    standardBenefits: populatedSBenefits,
  })
  return {
    topBenefits: populatedTBenefits,
    standardBenefits: populatedSBenefits,
  }
}
